import React from 'react'

const Other = () => {
  return (
    <div className="skills__content">
      <h3 className="skills__title">Other Skills</h3>

      <div className="skills__box">
        <div className="skills__group">
          <div className="skills__data">
            <div className="skills__header">
              <i className='bx bx-badge-check'></i>
              <h3 className="skills__name">Python</h3>
            </div>
            <div className="skill__bar">
              <div className="skill__bar-fill intermediate"></div>
            </div>
          </div>

          <div className="skills__data">
            <div className="skills__header">
              <i className='bx bx-badge-check'></i>
              <h3 className="skills__name">Java</h3>
            </div>
            <div className="skill__bar">
              <div className="skill__bar-fill intermediate"></div>
            </div>
          </div>

          <div className="skills__data">
            <div className="skills__header">
              <i className='bx bx-badge-check'></i>
              <h3 className="skills__name">SQL</h3>
            </div>
            <div className="skill__bar">
              <div className="skill__bar-fill basic"></div>
            </div>
          </div>
        </div>

        <div className="skills__group">
          <div className="skills__data">
            <div className="skills__header">
              <i className='bx bx-badge-check'></i>
              <h3 className="skills__name">Git</h3>
            </div>
            <div className="skill__bar">
              <div className="skill__bar-fill intermediate"></div>
            </div>
          </div>

          <div className="skills__data">
            <div className="skills__header">
              <i className='bx bx-badge-check'></i>
              <h3 className="skills__name">GitHub</h3>
            </div>
            <div className="skill__bar">
              <div className="skill__bar-fill intermediate"></div>
            </div>
          </div>

          <div className="skills__data">
            <div className="skills__header">
              <i className='bx bx-badge-check'></i>
              <h3 className="skills__name"> Media Editing</h3>
            </div>
            <div className="skill__bar">
              <div className="skill__bar-fill intermediate"></div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default Other